import { useCallback, useEffect, useState } from "react";
import {
  getDefaultVisibleColumnKeys,
  loadVisibleColumnKeys,
  resolveVisibleColumns,
  saveVisibleColumnKeys,
} from "./commissionsColumnPrefs";

export function useCommissionsColumnVisibility(report = "general") {
  const [visibleKeys, setVisibleKeysState] = useState(() =>
    loadVisibleColumnKeys(report),
  );

  useEffect(() => {
    setVisibleKeysState(loadVisibleColumnKeys(report));
  }, [report]);

  const setVisibleKeys = useCallback(
    (nextKeys) => {
      const resolved =
        typeof nextKeys === "function" ? nextKeys(visibleKeys) : nextKeys;
      const normalized = Array.isArray(resolved)
        ? resolved
        : getDefaultVisibleColumnKeys(report);
      setVisibleKeysState(normalized);
      saveVisibleColumnKeys(report, normalized);
    },
    [report, visibleKeys],
  );

  const visibleColumns = resolveVisibleColumns(report, visibleKeys);

  return {
    visibleKeys,
    visibleColumns,
    setVisibleKeys,
    resetVisibleColumns: () => setVisibleKeys(getDefaultVisibleColumnKeys(report)),
  };
}
